module.exports = __webpack_public_path__ + "static/media/master.f2766082.svg";